export default __webpack_public_path__ + "static/ecsdatapath-74e31f0b7fa5864ae9f435657c759a64.png";